import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from '@dialogexe/cw-website-store';

import './src/theme/main.scss';
import './src/layouts/assets/icons';
import './src/layouts/assets/images';

import { bootstrap } from './gatsby-builder/bootstrap/browser';

export const onClientEntry = bootstrap;

export const wrapRootElement = ({ element }) => {
    const store = createStore();
    return <Provider store={store}>{element}</Provider>;
};
